
import Candle from "../../../assets/filled/Candle.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CandleIcon({ className, dataTestid = "CandleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Candle data-testid={dataTestid} className={classes} {...rest} />
  );
}
